import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

function resolve(dict, path) {
  return path.split(".").reduce((acc, k) => (acc && acc[k] != null ? acc[k] : null), dict);
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const stored = localStorage.getItem("lumeo_lang");
    if (stored === "bs") return "hr"; // migrate old Bosnian preference to Croatian
    return stored || "en";
  });
  useEffect(() => { localStorage.setItem("lumeo_lang", lang); }, [lang]);

  const t = useMemo(() => {
    return (key, fallback) => {
      const val = resolve(translations[lang], key);
      if (val != null) return val;
      const en = resolve(translations.en, key);
      return en != null ? en : (fallback != null ? fallback : key);
    };
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t }), [lang, t]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
